import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { RadioChips } from "@/components/ax/RadioChips";
import { useI18n } from "@/i18n";

export const StepOptions = ({ s }) => {
  const { t } = useI18n();
  const revOptions = ["easy", "costly", "hard"].map((v) => ({ value: v, label: t(`rev.${v}`) }));
  return (
    <div data-testid="intake-step-4" className="enter mt-8">
      {s.options.length > 0 && (
        <ul data-testid="option-list" className="m-0 flex list-none flex-col gap-3 p-0">
          {s.options.map((o) => (
            <li
              key={o.id}
              data-testid={`option-card-${o.id}`}
              className="rounded-[12px] border border-ax-border bg-ax-surface p-4 shadow"
            >
              <p className="m-0 text-base font-medium leading-6 text-ax-text [overflow-wrap:anywhere]">{o.name}</p>
              {o.description && (
                <p className="m-0 mt-1 text-sm leading-5 text-ax-text-2 [overflow-wrap:anywhere]">{o.description}</p>
              )}
              <p className="m-0 mt-2 font-mono text-[13px] leading-[18px] text-ax-muted">{t(`rev.${o.reversibility}`)}</p>
            </li>
          ))}
        </ul>
      )}
      <div className={`flex flex-col gap-4 ${s.options.length ? "mt-8" : ""}`}>
        <Field
          label={t("opt.name")}
          maxLength={60}
          value={s.optDraft.name}
          onChange={(e) => {
            s.setOptDraft((d) => ({ ...d, name: e.target.value }));
            s.setErrors((x) => ({ ...x, optName: undefined }));
          }}
          error={s.errors.optName}
          testId="option-name-input"
        />
        <Field
          multiline
          label={t("opt.desc")}
          maxLength={200}
          value={s.optDraft.description}
          onChange={(e) => s.setOptDraft((d) => ({ ...d, description: e.target.value }))}
          testId="option-desc-input"
          className="[&_textarea]:min-h-[80px]"
        />
        <RadioChips
          legend={t("opt.rev")}
          name="reversibility"
          testId="option-reversibility"
          value={s.optDraft.reversibility}
          onChange={(v) => s.setOptDraft((d) => ({ ...d, reversibility: v }))}
          options={revOptions}
        />
        <Button
          disabled={!s.optDraft.name || !s.optDraft.reversibility || s.busy === "option"}
          busy={s.busy === "option"}
          onClick={s.addOption}
          data-testid="option-add-button"
          className="self-start"
        >
          {t("opt.add")}
        </Button>
      </div>
      {s.options.length < 2 && (
        <p data-testid="options-hint" className="m-0 mt-4 text-sm leading-5 text-ax-muted">
          {t("opt.min")}
        </p>
      )}
      {!s.aiOn && (
        <p data-testid="ai-no-consent" className="m-0 mt-4 text-sm leading-5 text-ax-muted">
          {t("ai.noConsent")}
        </p>
      )}
      {s.aiOn && s.left <= 0 && (
        <p data-testid="ai-quota-out" className="m-0 mt-4 text-sm leading-5 text-ax-muted">
          {t("ai.quotaOut")}
        </p>
      )}
      {s.aiOn && (
        <p data-testid="ai-quota" className="m-0 mt-4 font-mono text-[13px] leading-[18px] text-ax-muted">
          {t("ai.quota", { n: s.left })}
        </p>
      )}
    </div>
  );
};
